import { ChooseFingerModule } from 'modules';

export const ChooseFingerScreen = () => {
  return <ChooseFingerModule />;
};
